
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/hospital-cover/all",
      function () {
        return require("private-next-pages/health-insurance/hospital-cover/all/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-insurance/hospital-cover/all"])
      });
    }
  